import { render } from "./eduRaceInfo.vue?vue&type=template&id=46203951&scoped=true"
import script from "./eduRaceInfo.vue?vue&type=script&lang=js"
export * from "./eduRaceInfo.vue?vue&type=script&lang=js"

import "./eduRaceInfo.vue?vue&type=style&index=0&id=46203951&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46203951"]])

export default __exports__